import lottie from "lottie-web";

export function initLottieAnimation(container) {
    if (container && !container.dataset.lottieInitialized) {
        container.dataset.lottieInitialized = "true";
        lottie.loadAnimation({
            container: container,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: container.dataset.lottieSource,
        });
    }
}

export function initLottie() {
    const lottieContainers = document.querySelectorAll(".lottie-animation.quote");
    for (const container of lottieContainers) {
        if (!container.closest('.collapse:not(.show)')) {
            initLottieAnimation(container);
        }
    }
}
